import { EventName, RuntimeEngine } from '@easytwin/runtime';
import { useEffect } from 'react';

export function useBindEngineEvent(
  engine: RuntimeEngine | undefined,
  name: EventName,
  func: (...args: any[]) => void,
  deps: any[],
) {
  useEffect(() => {
    if (!engine) return;

    engine.on(name, func);
    return () => {
      engine.off(name, func);
    };
  }, [deps]);
}
